export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6Ldf_NAsAAAAAGSyGbjc9EcJY04vW2EPYjGVhYpP',
  },

  /*baseUrl: 'https://ontrailsssettlement-claimform-development.azurewebsites.net/api/'*/
  baseUrl: 'https://ontrailsssettlement-claimform.azurewebsites.net/api/'
  /*baseUrl: 'https://localhost:7249/api/'*/
};

